<template>
  <div class="row">
    <div class="col-xs-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'" />
        Voltar
      </button>
      <h1 class="page-header">
        Cadastrar Compromisso
      </h1>
      <div class="row">
        <div class="col-xs-12">

          <div class="col-xs-12 col-sm-4">
            <div :class="['form-group', { 'has-error': errors.has('periodo') }]">
              <label class="control-label custom-font">Período</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'calendar-alt'"></font-awesome-icon>
                  </span>
                  <select ref="periodo" class="form-control select-selected" name="periodo" v-model="model.periodo"
                    v-validate="'required'">
                    <option value="" disabled selected>Selecione o período</option>
                    <option v-for="p in listas.periodos" :key="p" :value="p">
                      {{ p }}
                    </option>
                  </select>
                </div>
                <small v-if="errors.has('periodo')" data-bv-validator="notempty" data-bv-validator-for="periodo"
                  class="help-block">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-4">
            <div :class="['form-group', { 'has-error': errors.has('unidade_executora') }]">
              <label class="control-label custom-font">Unidade</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'sitemap'"></font-awesome-icon>
                  </span>
                  <select ref="unidade_executora" class="form-control select-selected" name="unidade_executora" v-model="model.unidade_executora"
                    v-validate="'required'">
                    <option disabled value="">Selecione a unidade</option>

                    <optgroup label="Secretarias">
                      <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                        {{ s.sigla }}
                      </option>
                    </optgroup>

                    <optgroup label="Autarquias">
                      <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                        {{ a.sigla }}
                      </option>
                    </optgroup>

                  </select>
                </div>
                <small v-if="errors.has('unidade_executora')" data-bv-validator="notempty" data-bv-validator-for="unidade_executora"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-4">
            <SelectFuncionario
              v-model="model.responsavel_sshd"
              :label="'Funcionário Responsável'"
              :name="'responsavel_sshd'"
              :placeholder="'Pesquise pelo nome ou SSHD'"
              :is-required="true"
            />
          </div>

          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('titulo') }]">
              <label class="control-label custom-font">Título</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'tags'"></font-awesome-icon>
                  </span>
                  <input type="text" ref="titulo" name="titulo" v-model="model.titulo" placeholder="Título"
                    maxlength="255" class="form-control" v-validate="'required'" />
                  <div class="input-group-addon custom-input-group-addon-count" v-text="255 - model.titulo.length">
                  </div>
                </div>
                <small v-if="errors.has('titulo')" data-bv-validator="notempty" data-bv-validator-for="titulo"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('descricao') }]">
              <label class="control-label custom-font">Descrição</label>
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon :icon="'comment'"></font-awesome-icon>
                  </span>
                  <textarea ref="descricao" v-model="model.descricao" name="descricao"
                    placeholder="Descreva o compromisso..." maxlength="1000" class="form-control" v-validate="'required'"
                    rows="8"></textarea>
                  <div class="input-group-addon custom-input-group-addon-count" v-text="1000 - model.descricao.length">
                  </div>
                </div>
                <small v-if="errors.has('descricao')" data-bv-validator="notempty" data-bv-validator-for="descricao"
                  class="help-block" style="">Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>

          <!-- <div class="form-group col-xs-12">
            <label class="control-label custom-font">Metas</label>
            <div class="list-group">
              <a v-for="i in listas.metas" href="javascript:;" :key="i.codigo" @click.prevent="toogleshow(i)" :class="[
                'pad10 list-group-item col-md-2 custom-meta',
                { 'item-selected': i.selected }
              ]" style="padding:10px;text-align:center">
                <img :alt="i.titulo" style="max-width:129px;max-height:129px" :src="concatPathImage(i.imagem_url)" />
              </a>
            </div>
          </div> -->

          <div class="col-xs-12 margem-bottom">
            <router-link class="btn btn-default" :to="{ name: 'user_planogoverno' }">
              <font-awesome-icon :icon="'long-arrow-alt-left'"
                :class="'fa-long-arrow-alt-left-white'"></font-awesome-icon> Voltar
            </router-link>
            <button class="btn btn-default" v-on:click="save()">
              <font-awesome-icon :icon="'save'" :class="'fa-save-white'"></font-awesome-icon> Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-meta {
  color: #00615c;
}

.select-selected {
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-sitemap {
  color: #00615c;
}

.fa-user {
  color: #00615c;
}

.fa-check-double-white {
  color: #fff;
}

.fa-tags {
  color: #00615c;
}

.fa-comment {
  color: #00615c;
}

.fa-save-white {
  color: #fff;
}

.fa-long-arrow-alt-left-white {
  color: #fff;
}

.btn-voltar {
  margin-top: 20px;
}

.fa-calendar-alt {
  color: #00615c;
}
</style>

<script>
import { request } from '@/request'
import SelectFuncionario from '@/components/SelectFuncionario'

export default {
  name: 'plano-governo-save',
  inject: ["showConfirm"],
  components: {
    SelectFuncionario
  },
  data() {
    return {
      listas: {
        secretarias: [],
        autarquias: [],
        metas: [],
        status: ['Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'],
        periodos: ['2017-2020', '2021-2024', '2025-2028'],
        funcionarios: []
      },
      model: {
        titulo: '',
        descricao: '',
        periodo: '',
        unidade_executora: '',
        responsavel_sshd: '',
      },
      datetime: '?' + new Date().getTime()
    }
  },
  created() {
    this.loadUnidades()
    this.loadFuncionarios()
  },
  mounted() {
    this.$refs.periodo.focus()
  },
  computed: {
    isUpdate() {
      return this.model.hasOwnProperty('codigo')
    },
    isAdd() {
      return !this.isUpdate
    },
    urlToSave() {
      return this.isUpdate ? 'planogoverno/update' : 'planogoverno/add'
    },
    selecionaMetas() {
      return this.listas.metas
        .filter(i => {
          return i.selected
        })
        .map(i => {
          return i.codigo
        })
    }
  },
  methods: {
    toogleshow(e) {
      e.selected = !e.selected
    },
    saveSuccess(result) {
      this.$router.push({ name: 'user_planogoverno' })
      this.$toastr.s('O plano de governo foi salvo com sucesso.')
    },
    saveFail(result) {
      this.$toastr.e('Houve uma falha ao tentar salvar este item.')
    },
    save() {
      this.$validator.validateAll().then(async result => {
        if (!result) {
          const campoComErro = this.$validator.errors.items[0].field

          // se for o select personalizado, foca o input interno dele
          if (campoComErro === 'responsavel_sshd') {
            this.$refs.selectFuncionario.$el.querySelector('input').focus()
          } else {
            this.$refs[campoComErro].focus()
          }

          let msg = this.$validator.errors.items[0].msg
          if (campoComErro === 'descricao') {
            msg = msg.replace('descricao', 'Descrição')
          }

          this.$toastr.e(msg)
          return
        }

        const response = await request.post('planogoverno/compromisso', { ...this.model })

        if (response.status != 201) return this.saveFail()

        return this.saveSuccess()
      })
    },
    concatPathImage(file) {
      return this.$root.$data.imgUrl + file + this.datetime
    },
    async loadFuncionarios() {
      const { data, status } = await request.get('funcionario')

      if (status != 200) return this.$toastr.e('Houve um erro ao tentar carregar os funcionários!')

      this.listas.funcionarios = data
    },
    async loadUnidades() {
      const { data: { data: secretarias } } = await request.get('listar-secretarias')
      const { data: { data: autarquias } } = await request.get('listar-autarquias')

      this.listas.secretarias = secretarias
      this.listas.autarquias = autarquias
    }
  }
}
</script>

<style>
.list-group img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/Save.vue